import { Constants } from '../common/Constants';

export enum PopoverKey {
  HASDISMISSEDPOPOVER = 'hasDismissedPopover',
  HASDISMISSEDCOACHMARKWEB = 'hasDismissedCoachMarkWeb',
  SHOWCOMPAREMODAL = 'showCompareModal',
  SHOWCOMPARECOACHMARKWEB = 'showCompareCoachmarkWeb',
}

export interface PriorityItem {
  key: string;
  duration: number;
  releaseDate: string;
  priority: number;
  isSuperUser: boolean;
}

/**
 * @returns boolean indicating if the highest popover priority was updated in session storage.
 * true → updated, false → not updated, undefined → key not found in priority list
 */
const managePopoverPriority = (
  key: PopoverKey,
  keyPriorityFromLagoon: number,
  isSuperUser: boolean
): boolean | undefined => {
  const stored = sessionStorage.getItem(
    Constants.STORAGE_KEYS.SESSION.HIGH_PRIORITY_POPOVER
  );
  if (stored) {
    const currentKeyPriority: PriorityItem = JSON.parse(stored);
    if (keyPriorityFromLagoon > currentKeyPriority.priority) {
      return false;
    }
    if (currentKeyPriority.key === key) {
      return true;
    }
    if (!isSuperUser && currentKeyPriority.isSuperUser) {
      return true;
    }
  }

  sessionStorage.setItem(
    Constants.STORAGE_KEYS.SESSION.HIGH_PRIORITY_POPOVER,
    JSON.stringify({
      key,
      priority: keyPriorityFromLagoon,
      isSuperUser,
    })
  );
  window.dispatchEvent(new Event('popoverPriorityUpdated'));
  return true;
};

const isNotDismissed = (value: unknown): boolean =>
  value !== undefined && value !== 'y' && value !== false;

const updatePopoverPriority = (
  result,
  priorityList: PriorityItem[],
  isSuperUser: boolean = false
) => {
  const data =
    result?.data?.recommendationPreferencesStatus ??
    result?.data?.educationalContentStatus ??
    result?.data?.saveEducationalContentStatus;
  if (!data) return;

  if (isSuperUser) {
    const stored = sessionStorage.getItem(
      Constants.STORAGE_KEYS.SESSION.HIGH_PRIORITY_POPOVER
    );
    if (stored) {
      const currentKeyPriority = JSON.parse(stored);
      if (!currentKeyPriority.isSuperUser) {
        sessionStorage.removeItem(
          Constants.STORAGE_KEYS.SESSION.HIGH_PRIORITY_POPOVER
        );
      }
    }
  }

  const priorityMap = new Map(
    priorityList.map((item) => [item.key.toLocaleUpperCase(), item.priority])
  );

  Object.values(PopoverKey).forEach((popoverKey) => {
    if (isNotDismissed(data[popoverKey])) {
      const keyPriorityFromLagoon = priorityMap.get(
        popoverKey.toLocaleUpperCase()
      );
      if (keyPriorityFromLagoon === undefined) return;
      const isUpdated = managePopoverPriority(
        popoverKey,
        keyPriorityFromLagoon,
        isSuperUser
      );
      if (isUpdated === false) {
        data[popoverKey] = typeof data[popoverKey] === 'boolean' ? false : 'y';
      }
    }
  });
};

export { updatePopoverPriority };
